import jquery from 'jquery';
import FroalaEditor from 'froala-editor';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.normalizeHeadingsPlugin = function (editor) {
  function normalizeHeadings(clipboard_html) {
    // don't create/manipulate DOM elements if we don't have work to do
    if (clipboard_html.search(/h[1-6]/) === -1) {
      return clipboard_html;
    }

    const $pastedHTML = jquery('<div />', {html: clipboard_html});

    jquery('h1,h2', $pastedHTML).replaceWith(function () {
      return jquery('<h3 />', {html: jquery(this).html()});
    });

    jquery('h6', $pastedHTML).replaceWith(function () {
      return jquery('<h5 />', {html: jquery(this).html()});
    });
    return $pastedHTML.html();
  }

  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    editor.events.on('paste.afterCleanup', normalizeHeadings);
  }

  // Methods visible outside the plugin.
  return {_init};
};
